import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'
import Logo from './../inc/Logo';
import LogoSVG from './../inc/LogoSVG';
import SlideUpDownNav from './../inc/SlideUpDownNav';

class Catalogues extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let _this = this;
        let page_id = this.props.page_id;
        let catalogues = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.catalogues_content : [];  

        return (
            <section className="section" id="catalogues" data-logo="hide">
                <SlideUpDownNav {...this.props} fullpageApi={this.props.fullpageApi} />
                
                <div className="mole__about--catalogues fullW">
                    <div className="main-container">
                        <div className="inner-container">
                           <h6 className="font-lg-head c-general">Catalogues</h6>

                           <div className="grid">
                                {
                                    catalogues.map((catalogue, index) => {
                                        return (
                                            // <div className="grid-item" key={index}>
                                            //     <a href="javascript:" className="link"></a>
                                            //     <span className={`d-block bg-${index == catalogues.length - 1 ? 'wip' : catalogue.catalogue_name.toLowerCase()}`}><LogoSVG/></span>
                                            //     <p>{catalogue.catalogue_name}</p>
                                            // </div>
                                            <div className="grid-item" key={index}>
                                                {catalogue.upload_pdf && <a href={catalogue.upload_pdf.url} className="link" target="_blank"></a>}
                                                <span><img src={catalogue.catalogue_image.url} alt={catalogue.catalogue_name} title={catalogue.catalogue_name}/></span>
                                                <p>{catalogue.catalogue_name}</p>
                                            </div>
                                        )   
                                    })
                                }
                           </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default Catalogues;



// WEBPACK FOOTER //
// ./src/components/About/Catalogues.js